import React, { useState } from 'react'

const PersonHook = () => {
  const [personState, setPersons] = useState({
    persons: [
      { name: 'joe', age: 26 },
      { name: 'john', age: 32 },
      { name: 'sarah', age: 35 },
    ],
  })
  const [personSelected, setPersonSelected] = useState({
    person: 0,
  })
  const nextPersonHandler = () => {
    setPersonSelected({ person: 1 })
  }
  return (
    <>
      <div>{personState.persons[personSelected.person].name}</div>
      <br />
      <button onClick={nextPersonHandler}>{'next >'}</button>
    </>
  )
}

export default PersonHook
